jQuery(document).ready( function($) {
  const $leftChev = $('#left-arrow');
  const $rightChev = $('#right-arrow');
  const $slideArr = $('#orbit-slider input').toArray();

  let i = 2

  function switchSlide(a){
    if (i + a > $slideArr.length - 1) {
      i = 0;
      $slideArr[i].checked = true;
      return;
    } else if (i + a < 0) {
      i = $slideArr.length - 1;
      $slideArr[i].checked = true;
      return;
    }
    $slideArr[i + a].checked = true;
    i += a;
  }

  $leftChev.on('click', function(){
    switchSlide(-1);
  })
  $rightChev.on('click', function(){
    switchSlide(1);
  })
})
